const MonthlyProgressActionTypes = {
	GET_MONTHLY_PROGRESS_LIST_START: 'get_monthly_progress_start',
	GET_MONTHLY_PROGRESS_LIST_SUCCESS: 'get_monthly_progress_success',
	GET_MONTHLY_PROGRESS_LIST_FAILURE: 'get_monthly_progress_failure',
	GET_MONTHLY_PROGRESS_LIST_RESPONSE_RESET: 'get_monthly_progress_response_reset',
	GET_MONTHLY_PROGRESS_LIST_RESPONSE_CHANGED: 'get_monthly_progress_response_changed',
};
export default MonthlyProgressActionTypes;
